export const CONTRATO_FIELD_OBS = 'observaciones';
export const CONTRATO_FIELD_DESC = 'descripcion';

export type ContratoPlantillaCaret = {
  field: typeof CONTRATO_FIELD_OBS | typeof CONTRATO_FIELD_DESC;
  itemIndex?: number;
  start: number;
  end: number;
};

function readCaretFromElement(
  el: HTMLInputElement | HTMLTextAreaElement,
): ContratoPlantillaCaret | null {
  const field = el.dataset.contratoField;
  if (field !== CONTRATO_FIELD_OBS && field !== CONTRATO_FIELD_DESC) return null;
  const start = el.selectionStart ?? el.value.length;
  const end = el.selectionEnd ?? el.value.length;
  if (field === CONTRATO_FIELD_DESC) {
    const itemIndex = Number(el.dataset.itemIndex);
    if (Number.isNaN(itemIndex)) return null;
    return { field, itemIndex, start, end };
  }
  return { field, start, end };
}

export function captureContratoPlantillaCaret(
  fallback: ContratoPlantillaCaret | null,
): ContratoPlantillaCaret | null {
  const el = document.activeElement;
  if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) {
    return readCaretFromElement(el) ?? fallback;
  }
  return fallback;
}

export function insertAtCaret(value: string, start: number, end: number, insert: string) {
  const s = Math.max(0, Math.min(start, value.length));
  const e = Math.max(s, Math.min(end, value.length));
  return {
    value: `${value.slice(0, s)}${insert}${value.slice(e)}`,
    caret: s + insert.length,
  };
}

export function restoreContratoPlantillaCaret(caret: ContratoPlantillaCaret, position: number) {
  const selector =
    caret.field === CONTRATO_FIELD_OBS
      ? `[data-contrato-field="${CONTRATO_FIELD_OBS}"]`
      : `[data-contrato-field="${CONTRATO_FIELD_DESC}"][data-item-index="${caret.itemIndex}"]`;
  requestAnimationFrame(() => {
    const target = document.querySelector<HTMLInputElement | HTMLTextAreaElement>(selector);
    if (!target) return;
    target.focus();
    target.setSelectionRange(position, position);
  });
}
